<template>
  <div id="dialog-consulting-topic">
    <v-dialog max-width="600px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <!-- Topic -->
          <v-container grid-list-xl pb-0>
            <v-layout justify-center row wrap>
              <v-flex xs12>
                <div class="subheading">Consulting Topic</div>
              </v-flex>
              <v-flex sm3 v-if="formData.idx" xs12>
                <div class="caption grey--text">Cover Picture</div>
                <ConsultingTopicPicture :idx="formData.idx" condition="pictureCover" />
                <div class="caption grey--text">Icon Picture</div>
                <ConsultingTopicPictureIcon :idx="formData.idx" condition="pictureIcon" />
              </v-flex>
              <v-flex sm9 xs12>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
                <v-textarea
                  clearable
                  label="Description"
                  v-model="formData.description"
                ></v-textarea>
                <v-text-field
                  :error-messages="errors.collect('orders')"
                  clearable
                  data-vv-name="orders"
                  label="Orders"
                  v-model="formData.orders"
                  v-validate="'numeric'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- Beneficiary -->
          <ConsultingBeneficiary v-if="formData.idx" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click="doDelete(formData)" color="red" dark v-if="formData.idx">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn :loading="dialogLoading" @click.prevent="doSubmit()" color="green" dark
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConsultingTopicPicture from './ConsultingTopicPicture'
import ConsultingTopicPictureIcon from './ConsultingTopicPictureIcon'
import ConsultingBeneficiary from '../../views/admin/ConsultingBeneficiary'
import firebase from 'firebase/app' // Storage
export default {
  name: 'dialog-consulting-topic',
  components: {
    ConsultingTopicPicture,
    ConsultingTopicPictureIcon,
    ConsultingBeneficiary
  },
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ConsultingTopic.idx) {
        this.formData = this.$store.getters['ConsultingTopic/getAll'].filter(
          item => item.idx == this.$store.state.ConsultingTopic.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ConsultingTopic.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ConsultingTopic/UPDATE_DIALOG', newValue)
      }
    }
  },
  async created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          await this.doInsert()
          this.$store.commit(`ConsultingTopic/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async doInsert() {
      try {
        const data = {
          ...this.formData,
          createdBy: localStorage.getItem('tokenAdmin')
        }
        this.$store.dispatch(`ConsultingTopic/insert`, data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async doDelete(item) {
      try {
        if (confirm(`คุณแน่ใจที่จะลบ ${item.idx} ?`)) {
          // Delete in DB
          this.$store.dispatch('ConsultingTopic/delete', item.idx)
          if (item.pictureCover) {
            firebase
              .storage()
              .refFromURL(item.pictureCover)
              .delete()
          }
          if (item.pictureIcon) {
            firebase
              .storage()
              .refFromURL(item.pictureIcon)
              .delete()
          }
          this.$store.commit('ConsultingTopic/UPDATE_DIALOG', false)
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('ConsultingTopic/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingTopic/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
